/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Enabled_With_LimitedInputs */

const en_disabled_websites_enabled_with_limited = /** @type {(inputs: Disabled_Websites_Enabled_With_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled (limited compatibility)`)
};

const es_disabled_websites_enabled_with_limited = /** @type {(inputs: Disabled_Websites_Enabled_With_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitado (compatibilidad limitada)`)
};

/**
* | output |
* | --- |
* | "Enabled (limited compatibility)" |
*
* @param {Disabled_Websites_Enabled_With_LimitedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_enabled_with_limited = /** @type {((inputs?: Disabled_Websites_Enabled_With_LimitedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Enabled_With_LimitedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_enabled_with_limited(inputs)
	return en_disabled_websites_enabled_with_limited(inputs)
});